import { Link } from 'react-router';
import { Alert } from 'components/common';
import { useUser } from 'libs';

const PastDuePaymentsBanner = () => {
  const user = useUser();
  return user.features.has_past_due_payments ? (
    <Alert variant="error" isImportant>
      One or more of your subscription payments are past due.{' '}
      <Link to="/settings/payment-method">Update your payment method</Link> to restore feature access.
    </Alert>
  ) : null;
};

export default PastDuePaymentsBanner;
